import { createFileRoute } from '@tanstack/react-router';

import { PaymentsPage } from '@/features/collections';
import { workspaceSearchSchema } from '@/patterns';
import { currentPeriod } from '@/shared/lib/dates';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/collections/payments/')({
  validateSearch: workspaceSearchSchema.extend({ record: zSearchText() }),
  staticData: { crumb: 'collections:nav.payments' },
  component: function CollectionsList() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const onSearchChange = (patch: Record<string, unknown>, o?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false });
    return (
      <PaymentsPage
        search={search}
        period={search.period ?? currentPeriod()}
        bank={search.bank}
        onScopeChange={(patch) => onSearchChange({ ...patch, page: undefined })}
        onSearchChange={onSearchChange}
      />
    );
  },
});
